module.exports = __webpack_public_path__ + "img/infoExpert.5d926a41.png";